import React from "react";

export default function ML_Linear_Graphs() {
  return (
    <div>
      <h1>ML_Linear_Graphs</h1>
      <p>This is the ML_Linear_Graphs component.</p>
    </div>
  );
}
